import axios from "axios";
import {axiosCatchHandler} from "../sharedGlobal";

const reports = {
  namespaced: true,
  state: {
    reports: null,
    paginate: null,
  },
  mutations: {
    setReports(state, data){
      state.reports = data.data;
      state.paginate = data;
    }
  },
  actions: {
    fetchReports: ({commit}, all_results = false) =>
      axios.get(`/ajax/reports/get-my-reports${all_results ? `?all_results=${all_results}` :''}`)
        .then(({data}) => commit('setReports', data)),
    createReport: ({dispatch}, payload) =>
      new Promise((resolve, reject) => {
        axios.post('/ajax/reports/create-report', {
            data: payload
          })
          .then(response => {
            dispatch('fetchReports').then(() => {
              resolve(response.data);
            });
          })
          .catch((e) => axiosCatchHandler(e, ({response}) => {
            reject(response.data.errors);
          }));
      }),
    navigatePagination: ({commit}, {url}) =>
      axios.get(url)
        .then(({ data }) => commit('setReports', data)),
    searchReports: ({commit}, payload) =>
      axios.get(`/ajax/reports/get-my-reports?search=${payload}`)
        .then(({ data }) => commit('setReports', data)),
    sortReports: ({commit}, {sortBy, sortDirection}) =>
      axios.get(`/ajax/reports/get-my-reports?sortBy=${sortBy}&sortDirection=${sortDirection}`)
        .then(({ data }) => commit('setReports', data)),
    deleteReports: ({dispatch}, selected) =>
      axios.post('/ajax/reports/delete-reports', {
          data: selected
        })
        .then(response => {
          dispatch('fetchReports');
          dispatch('reportSchedules/fetchSchedules', {}, {root:true});
          return response;
        }),
  },
};

export default reports;
